// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

const isSnowflakeKey = objectOf({
  id: string,
  partner_name: string,
  user: string,
  role: string,
  snowflake_account: string,
  rsa_public_key: string,
  rsa_public_key_old: maybe(string),
});

const isRedshiftKey = objectOf({
  id: string,
  partner_name: string,
  user: string,
  password: string,
  host: string,
  port: number,
  ec2_host: maybe(string),
  ssh_user: maybe(string),
  ssh_port: maybe(number),
  rsa_public_key: maybe(string),
  rsa_public_key_old: maybe(string),
});

const isBigQueryKey = objectOf({
  id: string,
  partner_name: string,
  service_account_name: string,
  service_account_creds: string,
});

const isDatabricksKey = objectOf({
  id: string,
  partner_name: string,
  access_token: string,
  cred_name: string,
  hostname: string,
  http_path: string,
});

const isS3Key = objectOf({
  id: string,
  partner_name: string,
  role_arn: string,
  external_id: string,
});

const isFabricKey = objectOf({
  id: string,
  partner_name: string,
  tenant_id: string,
  principal_id: string,
  client_secret: string,
  name: string,
  connection_string: string,
  azure_vm: maybe(string),
  ssh_user: maybe(string),
  ssh_port: maybe(number),
  rsa_public_key: maybe(string),
  rsa_public_key_old: maybe(string),
});

export const isIntegrationsDirectCdiImportKeysAppGroupIdResult = objectOf({
  snowflake: arrayOf(isSnowflakeKey),
  redshift: arrayOf(isRedshiftKey),
  bigquery: arrayOf(isBigQueryKey),
  databricks: arrayOf(isDatabricksKey),
  s3: arrayOf(isS3Key),
  fabric: arrayOf(isFabricKey),
});
